import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ImageService } from './image.service';

export const Ng1ImageModule = angular
  .module('control-room.shared.services.image', [])
  .factory('crImageService', downgradeInjectable(ImageService));